<template>
  <div>
    <div class="main">
      <img  src="static/img/act/2/top.jpg"   />
        <img  src="static/img/act/2/title.jpg"   />
        <div style="text-align: center;background-color: #ffddb7;margin-top: 3%;">
          <img  src="static/img/act/2/btn-down.png" style="width: 8%; text-align: center;"   @click="displayDesc()"  v-bind:class="{act2down:isActt2DescClass,act2downno:!isActt2DescClass}"/>
        </div> 
        <div class="act-2-desc" style="background-color: #ffddb7; font-size: 0.26rem;color: #0d0e10; width: 100%;overflow: hidden;" v-bind:style="{height: actt2DescHeight}">
          <div class="act-2-desc-content" style="background-color: #cfa06a; color: #0d0e10;    margin: 3% 5% 3% 5%;padding: 5%;    width: 80%; border-radius: 15px; overflow-y: auto;overflow-x: hidden;overflow-y: auto;overflow-x: hidden;height: 180px;" >
            <p>　　融水素有“百节之乡”的美誉，每年全县有大小节日上百个，分布在各个乡镇的村屯里。节日活动项目繁多，内容丰富多彩，既有传统祭祀、敬祖仪式，又有比赛娱乐项目，其中以吹芦笙跳踩堂最为盛行，苗、瑶、侗、壮族春节期间的活动都少不了这个节目。同时还有斗马、斗牛、斗鸡、赛马、芒篙等多项内容。其中，春节期间从正月初三至正月十七天天有坡会，称之为『苗族系列坡会群』，是指在每年春季的农历正月初三至十七这段时间内，广西壮族自治区融水县各乡镇村屯的节日活动。每天一个坡会，排列成序，连续不断，男女青年赶坡会应接不暇。是以苗族为主的各族人民悼念先烈、禳灾祈福、鼓舞斗志、交流感情、集体聚会娱乐的盛大民间传统节日。起源自然，文化形态体现在歌、舞、乐当中，『苗族系列坡会群』已被列为第一批国家非物质文化遗产名录。</p>
            <p>　　系列坡会群活动主要有：整英坡会（正月初三）、嘎直坡会（正月初四）、平卯坡会（正月初五）、沛松坡会（正月初六）、拱洞坡会（正月初七）、能邦坡会（正月初八）、乌勇芒篙坡会（正月初九）、整依直坡会（正月初十）、整堆坡会（正月十一）、百鸟衣坡会（正月十二）、安太坡会（正月十三）、更喔坡会（正月十四）、大坡坡会（正月十五）、古龙坡会（正月十六）、安陲芒篙坡会（正月十七）。</p>
          </div>
        </div>
        <img  src="static/img/act/2/list-title.jpg"   />
        <div style="position: relative;">
          <img  src="static/img/act/2/bg.jpg"   />
          <div class="act-2-link"  >
            <router-link :to="{ path: '/act2/main/news', query: { id: 64045}}">
              <img src="static/img/act/2/list/1.png?v=1" />
            </router-link>
            <router-link :to="{ path: '/act2/main/news', query: { id: 64049}}">
              <img src="static/img/act/2/list/2.png?v=1"  />
            </router-link>
            <router-link :to="{ path: '/act2/main/news', query: { id: 64057}}">
              <img src="static/img/act/2/list/3.png?v=1"  />
            </router-link>
            <router-link :to="{ path: '/act2/main/news', query: { id: 64056}}">
              <img src="static/img/act/2/list/4.png?v=1"  />
            </router-link>
            <router-link :to="{ path: '/act2/main/news', query: { id: 64055}}">
              <img src="static/img/act/2/list/5.png?v=1"  />
            </router-link>
            <router-link :to="{ path: '/act2/main/news', query: { id: 64046}}">
              <img src="static/img/act/2/list/6.png?v=1"  />
            </router-link>
            <router-link :to="{ path: '/act2/main/news', query: { id: 64053}}">
              <img src="static/img/act/2/list/7.png?v=1"   />
            </router-link>
          </div>
        </div>
      </div>
 

  </div>
</template>

<script>
  import { Tabbar, TabbarItem  } from 'vant';
  //动画
  import Velocity from 'velocity-animate'
  //窗口
  import {Act1NewsListDialog} from '@/api/MenuDialog' 

  export default {
    name: 'Act4Main',
    components: {
      'van-tabbar':Tabbar,
      'van-tabbar-item':TabbarItem, 
      'list-style-1':()=>{
	    return import('@/components/list/ListStyle1.vue')
	    },
    },
    data() {
      return { 
        actt2DescHeight:'0px',
        isActt2DescClass:false,
      }
    }, 
    destroyed(){
    },
    mounted() {
    },
    created() {
      //页面设置
      this.setDocumentV2(
        "苗族系列坡会群", 
        "",
        "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/img/share.jpg?v=2"
      );
      _czc.push(['_trackEvent', '苗族系列坡会群', '点击', '主页面','0','2']);      
    },
    methods: {
      //显示描述
      displayDesc(){
        if(this.actt2DescHeight=='240px'){
          this.actt2DescHeight = "0px"
          this.isActt2DescClass = false
        }else{
          this.actt2DescHeight = "240px"
          this.isActt2DescClass = true
        }
      },  
    }
  }
</script>

<style scoped>
  .main{
    position: absolute;
    width: 100%;
    height: calc(100% - 1.37rem);
    background-color: #ffddb7;
    font-size: 0;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .main img{
    width: 100%;
  }
  
.act-2-link {
  position: absolute;
  left: 9%;
  top: 0%;
  width: 82%;
  height: 15%;
}

.act-2-link img {
  width: 100%;
  margin-top: 4%;
}

.act-2-desc {
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}

.act2down {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}

.act2downno {
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

.act-2-desc-content::-webkit-scrollbar {
  width: 7px;
  /*滚动条宽度*/
  height: 7px;
  /*滚动条高度*/
}


/*定义滚动条轨道 内阴影+圆角*/

.act-2-desc-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  /*滚动条的背景区域的圆角*/
  background-color: rgba(190, 109, 4, 1);
  /*滚动条的背景颜色*/
}


/*定义滑块 内阴影+圆角*/

.act-2-desc-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #FFFFFF;
  /*滚动条的背景颜色*/
}
</style>


// WEBPACK FOOTER //
// src/components/act/2/main.vue